import { Injectable } from '@angular/core';
import {CrudService} from "../../services";
import {AnnualFeeDeduction, MicroPaymentSession} from "../../dto/invoice";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {DataListModel} from "../../models/data-list-model";
import {DateTableFilter} from "../../table-datasouces/date-table-filter";
import {PrevNextModel} from "../../models/prev-next-model";
import {toISODateString} from "../../providers/app-date-adapter";
import {PrevNextIdModel} from "../../models/prev-next-id-model";
import {WhiteListedBankAccount} from "../../dto/trustPayTransaction";

@Injectable({
  providedIn: 'root'
})
export class WhiteListedBankAccountsService implements CrudService<WhiteListedBankAccount> {


  readonly apiPath = 'white-listed-bank-accounts/';

  constructor(private http: HttpClient) { }
  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<WhiteListedBankAccount>;
  }
  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string) {
    const params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', encodeURIComponent(filterString))
      .set('sortField', sortField)
      .set( 'sortDirection', sortDirection )
      .set( 'someAdditionalData', someAdditionalData );
    return this.http.get(this.apiPath, { params }) as Observable<DataListModel<WhiteListedBankAccount>>;
  }






  add(item: WhiteListedBankAccount): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  update(item: WhiteListedBankAccount) {
    return this.http.put(this.apiPath, item) as Observable<AnnualFeeDeduction>;
  }

  delete(id: any) {
    return this.deleteMany([id]);
  }
  restore(id: any) {
    return this.restoreMany([id]);
  }

  deleteMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }

  restoreMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath + "restore", null, { params: httpParams });
  }

  getPrevNextIds(filters: DateTableFilter, whiteListedBankAccountId: number): Observable<PrevNextIdModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${whiteListedBankAccountId}/prev-next-ids`, { params }) as Observable<PrevNextIdModel>;
  }

  getByCustomerId( customerId: number ): Observable<WhiteListedBankAccount[]> {

    const params = new HttpParams()
      .set('customerId', customerId)
    ;
    return this.http.get(this.apiPath+'by-customer-id', {params}) as Observable<WhiteListedBankAccount[]>;
  }



  getFilterParams(filters: DateTableFilter): HttpParams {
    const str =  filters != null ? filters.str || '' : '';
    const dateFilterCols = filters != null ? filters.dateFilterCols || [] : [];
    const startFilterDate = filters != null ? filters.startFilterDate || null : null;
    const endFilterDate = filters != null ? filters.endFilterDate || null : null;
    const someAdditionalData = filters != null ? filters.someAdditionalData || null : null;

    let params = new HttpParams()


      .set('filterString', str)
      .set('startFilterDate', toISODateString(startFilterDate))
      .set('endFilterDate', toISODateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (filters != null && filters.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters != null && filters.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }

    if (filters != null && filters.enumFilter) {
      params = params.set('enumFilter', filters.enumFilter.value+'_'+filters.enumFilter.key);
    }


    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return params;
  }


}
